import { useEffect } from 'react';

import { Vendor } from 'entities/Vendors';
import { editOrderItemSourcingActions } from 'features/EditOrderItemSourcing';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';

interface UseOrderItemInitializationProps {
    selectedItemData:
        | {
              selectedProposals: any[] | undefined;
              proposals: any[] | undefined;
              isSourcingOverridden: boolean | undefined;
          }
        | undefined;
    orderId: string | undefined;
    itemId: string | undefined;
    selectedQuantity: number | undefined;
    vendorsMap: Record<string, Vendor> | undefined;
    isPreSubmission: boolean;
}

// This hook is used to initialize the EditOrderItemSourcing feature state
export const useEditOrderItemInit = ({
    selectedItemData,
    orderId,
    itemId,
    selectedQuantity,
    vendorsMap,
    isPreSubmission,
}: UseOrderItemInitializationProps): void => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (
            selectedItemData &&
            orderId &&
            itemId &&
            selectedItemData.selectedProposals &&
            vendorsMap
        ) {
            // Calculate total available quantity from all proposals
            const availableQuantity =
                selectedItemData.proposals?.reduce(
                    (acc, proposal) => acc + (proposal.availableQuantity || 0),
                    0,
                ) || 0;

            // Always re-initialize if data changes (handles page refresh, navigation, etc.)
            dispatch(
                editOrderItemSourcingActions.initializeEditing({
                    itemId,
                    orderId,
                    totalQuantity: selectedQuantity || 0,
                    selectedProposals: selectedItemData.selectedProposals,
                    proposals: selectedItemData.proposals || [],
                    isSourcingOverridden:
                        selectedItemData.isSourcingOverridden || false,
                    availableQuantity,
                    vendorsMap,
                    isPreSubmission,
                }),
            );
        }
    }, [
        dispatch,
        selectedItemData,
        orderId,
        itemId,
        selectedQuantity,
        vendorsMap,
        isPreSubmission,
    ]);
};
